import { observable } from 'mobx';
import { periodTypes } from '@/store/mapping';

export default class PartnerControlStore {
  @observable period = '';
  @observable periodType = 'month';
  @observable periodTypes = periodTypes;
  @observable incomeTaxesMode = 'income';
}
